<template>
	<div>
		<v-row class="mt-2">
			<v-col md="12">
				<h1 class="mt-2 mb-6">Acquisto nuova auto</h1>
			</v-col>
			<v-col md="12">
				<v-alert type="info" text>
					I dati vengono aggiornati solo una volta al giorno. La ricerca filtra per Telaio, ID Card (convertito a VARCHAR), Codice Fiscale, Cognome cliente, Nome cliente, Comune, Email, Organizzato attivazione.
				</v-alert>
			</v-col>
			<v-col md="6"></v-col>
			<v-col md="6">
				<v-text-field v-model="tableSearch" append-icon="mdi-magnify" label="Ricerca libera" hide-details clearable :filled="tce.filled" :outlined="tce.outlined" :solo="tce.solo" :dense="tce.dense" @input="onSearchDebounced"></v-text-field>
			</v-col>
		</v-row>
		<v-row class="mt-5">
			<v-col>
				<v-data-table 
					class="reportTable"
					:class="{ 'pagination-disabled': loading }"
					item-class="caption"
					:headers="tableHeaders"
					:items="reportData"
					:loading="loading"
					loading-text="Caricamento..."
					:server-items-length="totalItems"
					:options.sync="tableOptions"
					:footer-props="{ 'items-per-page-options': [20, 50, 100, 200] }"
					@update:options="fetchDataPaged"
				>
					<template v-slot:[`item.attivazione`]="{ item }">
						<span class="text-no-wrap">{{ item.attivazione | reportShortDate }}</span>
					</template>
					<template v-slot:[`item.cessazione`]="{ item }">
						<span class="text-no-wrap red--text">{{ item.cessazione | reportShortDate }}</span>
					</template>
					<template v-slot:[`item.email`]="{ item }">
						<v-btn v-if="item.email" text x-small :href="'mailto:'+item.email" style="margin-left:0;padding-left:0" @click.stop="nop">{{ item.email }}</v-btn>
					</template>
					<template v-slot:[`item.telmobile`]="{ item }">
						<v-btn :disabled="!item.telmobile" text x-small :target="cellularOpenMode ? '_blank' : ''" :href="(cellularOpenMode ? 'https://api.whatsapp.com/send?phone=' : 'tel:') + item.telmobile" style="margin-left:0;padding-left:0" @click.stop="nop">{{ item.telmobile }}</v-btn>
					</template>
				</v-data-table>
			</v-col>
		</v-row>
		<v-row>
			<v-col>
				<v-btn color="grey darken-3" small outlined :loading="loadingExcel" :disabled="loadingExcel" @click="generaReportXlsx"><v-icon left>mdi-microsoft-excel</v-icon> genera e scarica report xlsx</v-btn>
			</v-col>
		</v-row>

		<debug-panel label="reportData" class="mt-6">
			{{ reportData }}
		</debug-panel>
	</div>
</template>

<script>
/**********************************************************************************************
**** REPORT ACQUISTO NUOVA AUTO ***************************************************************
***********************************************************************************************
* Con paginazione server-side per gestire grandi volumi di dati
*/
import DebugPanel from '@/components/debug-panel'
import _ from 'lodash'
//
export default {
	name: 'ReportNuoveAuto',
	components: { DebugPanel },
	props: {

	},
	data: () => {
		return {
			loading: false,
			tableSearch: '',
			tableHeaders: [
				{ text: 'ID-card' 			, value: 'idcard' 			},
				{ text: 'Stato Card' 			, value: 'Stato_Card' 			},
				{ text: 'Data attivazione' 		, value: 'Data_attivazione' 		},
				{ text: 'Cod Fiscale' 		, value: 'Cod_Fiscale' 		},
				{ text: 'Cliente' 			, value: 'Cliente' 			},
				{ text: 'Sesso' 				, value: 'Sesso' 			},
				{ text: 'Indirizzo' 		, value: 'Indirizzo' 		},
				{ text: 'Cap' 				, value: 'CAP' 				},
				{ text: 'Comune' 			, value: 'Comune' 			},
				{ text: 'Provincia' 		, value: 'Provincia' 		},
				{ text: 'Data di nascita' 		, value: 'Data_nascita' 		},
				{ text: 'Tel. fisso' 		, value: 'telfiTelefono_Fissosso' 		},
				{ text: 'Tel. mobile' 		, value: 'Telefono_Cellulare' 		},
				{ text: 'Email' 			, value: 'E_Mail' 			},				
				{ text: 'Telaio' 			, value: 'Telaio' 			},				
				{ text: 'Org. di attivazione' 			, value: 'Org_attivazione' 			},				
			],
			reportData: [],
			totalItems: 0,
			tableOptions: {
				page: 1,
				itemsPerPage: 20,
				sortBy: [],
				sortDesc: []
			},
			errors: [],
			loadingExcel: false,
		}
	},
	computed: {
		appSetup() { return window.setup },
		viewDebugElements() { return this.$store.getters['viewDebugElements'] },
		setup() { return this.$store.getters['setup'] },
		tce() { return this.$store.getters['tipologiaCampiEdit'] },
		compactVisualization() { return this.$store.getters['compactVisualization'] },	
		currentUser() { return this.$store.getters['currentUser'] },
		isAdmin() { return this.currentUser.IsAdmin || this.currentUser.IsSuperuser},
		cellularOpenMode() { return this.$store.getters['cellularOpenMode'] },
	},
	created: function () {
		// Debounce per la ricerca (attende 500ms prima di chiamare API)
		this.onSearchDebounced = _.debounce(this.onSearch, 500)
	},
	methods: {
		// Chiamato quando cambiano le opzioni della tabella (pagina, ordinamento)
		fetchDataPaged(options) {
			// Blocca chiamate multiple durante il caricamento
			if (this.loading) return
			this.loading = true
			const { page, itemsPerPage, sortBy, sortDesc } = options
			
			const payload = {
				page: page,
				pageSize: itemsPerPage,
				search: this.tableSearch || null,
				sortBy: sortBy.length > 0 ? sortBy[0] : null,
				sortDesc: sortDesc.length > 0 ? sortDesc[0] : false
			}
			
			this.$store.dispatch('genericApiPost', {apiUrl: '/report/nuoveAutoPaged', value: payload}).then(result => {
				this.reportData = result.items
				this.totalItems = result.totalCount
			}).catch(error => {
				this.errors.push({text: error, pre: true})
			}).finally(() => {
				this.loading = false
			})
		},
		// Chiamato quando l'utente digita nella ricerca
		onSearch() {
			// Reset alla prima pagina quando si cerca
			this.tableOptions.page = 1
			this.fetchDataPaged(this.tableOptions)
		},
		nop(){

		},
		// genera e scarica il report in formato xlsx
		generaReportXlsx() {
			this.loadingExcel = true
			this.$store.dispatch('genericApiPost', {apiUrl: '/report/nuoveAutoXlsx', value: {}, options: {responseType: 'blob'}}).then(blob => {
				// crea il link per scaricare il file
				let link = document.createElement('a')
				document.body.appendChild(link) // fix per firefox
				link.setAttribute('type', 'hidden') // fix per firefox
				link.href = window.URL.createObjectURL(blob)
				link.target = '_blank'
				link.download = 'report-nuove-auto.xlsx'
				link.click()
				document.body.removeChild(link)
			}).catch(error => {
				this.errors.push({text: error, pre: true})
			}).finally(() => {
				this.loadingExcel = false
			})
		}
	},
}
</script>

<style scoped lang="less">
/* Disabilita i pulsanti di paginazione durante il caricamento */
.pagination-disabled ::v-deep .v-data-footer {
	pointer-events: none;
	opacity: 0.5;
}
</style>